import { gql } from '@apollo/client';

export const POWER_SUPPLIES = gql`
  query getAvailablePowerSupplies($inputPowerSupply: String!) {
    getAvailablePowerSupplies(inputPowerSupply: $inputPowerSupply)
  }
`;
